import { useFormContext, type FieldValues } from 'react-hook-form'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'

export interface SelectOption {
	value:     string
	label:     string
	disabled?: boolean
}

export interface SelectFieldProps {
	name:         string
	label?:       string
	placeholder?: string
	disabled?:    boolean
	options:      SelectOption[]
	className?:   string
	size?:        'sm' | 'md'
	width?:       'auto' | 'sm' | 'md' | 'lg' | 'xl' | 'full'
}

export function SelectField({
	name, label, placeholder, disabled, options,
	className, size = 'md', width = 'full',
}: SelectFieldProps) {
	const form = useFormContext<FieldValues>()
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem className={className}>
					{label && <FormLabel>{label}</FormLabel>}
					<Select
						value={field.value as string | undefined}
						onValueChange={field.onChange}
						disabled={disabled}
					>
						<FormControl>
							<SelectTrigger size={size} width={width}>
								<SelectValue placeholder={placeholder} />
							</SelectTrigger>
						</FormControl>
						<SelectContent>
							{options.map((opt) => (
								<SelectItem key={opt.value} value={opt.value} disabled={opt.disabled}>
									{opt.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
